// extracted by mini-css-extract-plugin
module.exports = {"root":"sidebar_root__n8iaE","active":"sidebar_active__12cQW"};